import { useEffect } from "react";
import { useForm } from "@/base/utils/index";
import { useLoader } from "@/app/hook/use-loader";
import { useLocalization } from "@/app/hook/use-localization";
import { useModalTrackingView } from "@/module/modal-tracking-view";
import { useTable } from "../hooks/use-table";

export function usePageDeliveryHook() {
  const [form] = useForm();
  const localization = useLocalization();
  const { setLoader } = useLoader();
  const { currentLang } = localization;
  const { fetchModalTrackingView } = useModalTrackingView();

  const controllerDataTable = useTable();

  useEffect(() => {
    setLoader(false);
  }, []);

  return { form, currentLang, controllerDataTable, fetchModalTrackingView };
}
